import React, {useContext} from "react";
import {BrandContext} from "@context/BrandContext";

const ListItemTestAssignmentPlain = props => {
    const {testAssignment} = props;
    const brandConfig = useContext(BrandContext);

    return <>
        {testAssignment.testAssignmentId === undefined &&
            <tr>
                {(brandConfig.enableExams || brandConfig.enableDiagnosticTests) &&
                    <td>{testAssignment.testPurposeDescription}</td>
                }
                <td>
                    {(testAssignment.name !== undefined) ? testAssignment.name: testAssignment.testName}
                    {testAssignment.testType === 'REVISION' &&
                        <span> - {brandConfig.revisionTestName}</span>
                    }
                </td>
                <td>{testAssignment.teacherName}</td>
                <td>Not assigned</td>
                <td>N/A</td>
                <td>N/A</td>
            </tr>
        }
        {testAssignment.testAssignmentId !== undefined &&
            <tr>
                {(brandConfig.enableExams || brandConfig.enableDiagnosticTests) &&
                    <td>{testAssignment.testPurposeDescription}</td>
                }
                <td>
                    {testAssignment.testName}
                    {testAssignment.testType === 'REVISION' &&
                        <span> - {brandConfig.revisionTestName}</span>
                    }
                </td>
                <td>
                    {testAssignment.assignedBy}
                </td>
                <td>
                    {testAssignment.percentStudentsComplete == 100 &&
                        <>Completed</>
                    }
                    {testAssignment.percentStudentsComplete < 100 &&
                        <>
                            {testAssignment.expired &&
                                <>Expired</>
                            }
                            {!testAssignment.expired &&
                                <>
                                    {testAssignment.inProgress &&
                                        <>In progress</>
                                    }
                                    {!testAssignment.inProgress &&
                                        <>Assigned</>
                                    }
                                </>
                            }
                        </>
                    }
                </td>
                <td>
                    {testAssignment.testAveragePercent == 0 &&
                        <>N/A</>
                    }
                    {testAssignment.testAveragePercent > 0 &&
                        <>{testAssignment.testAveragePercent}%</>
                    }
                </td>
                <td>
                    {testAssignment.percentStudentsComplete}%
                </td>
            </tr>
        }
    </>
}

export default ListItemTestAssignmentPlain;